export const Types = {
  SET_HOTELS: 'mapHotel/SET_HOTELS',
  SET_VIEW_TYPE: 'mapHotel/SET_VIEW_TYPE',
};

interface IMapHotel {
  hotelId: number;
  viewType: 'normal' | 'fullscreen';
}

const initialState: IMapHotel = {
  hotelId: 0,
  viewType: 'normal',
};

export default function reducer(state = initialState, action: any = {}) {
  switch (action.type) {
    case Types.SET_HOTELS:
      return { ...state, hotelId: action.payload };

    case Types.SET_VIEW_TYPE:
      return { ...state, viewType: action.payload };

    default:
      return state;
  }
}

export const setHotels = (hotelId: IMapHotel['hotelId']) => ({
  type: Types.SET_HOTELS,
  payload: hotelId,
});

export const setViewType = (viewType: IMapHotel['viewType']) => ({
  type: Types.SET_VIEW_TYPE,
  payload: viewType,
});

export const HotelsActions = {
  setViewType,
  setHotels,
};
